/** @format */

import { Script } from 'gatsby';
import React, { memo, ReactNode } from 'react';
import { usePortalCode } from './@ducks/shared/hooks/usePortalCode';

interface Props {
  children: ReactNode;
}

export const BaseHead = memo(({ children }: Props) => {
  const { isExternalPortalCode } = usePortalCode();

  return (
    <>
      {!isExternalPortalCode && (
        <Script
          id="ze-snippet"
          strategy="idle"
          src="https://static.zdassets.com/ekr/snippet.js?key=5bc50942-a5f6-4b71-8fae-95da00d04253"
        />
      )}
      <meta name="theme-color" content="#FFFFFF" />
      {children}
    </>
  );
});
